var render = function render(){var _vm=this,_c=_vm._self._c;return _c('parallax',{staticClass:"page-header header-filter pt-0 header-small",attrs:{"parallax-active":"true"}},[_c('div',{staticClass:"container m-auto"},[_c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item"},[_c('h1',{staticClass:"title mt-0 text-center"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }